<template>
  <div>
    <div class="row">
    <div class="col-md-10 col-md-offset-1">
    <h4 style="margin-top:0;" class="text-center">Your information is confidential</h4>
<h4 class="text-center seiu"> Your participation will help enforce Aerosol Transmissible Diseases (ADT) Standard 
(California Code of Regulations, title 8, section 5199).</h4>
    </div>
    <div class="col-md-1">
    </div>
    </div>
    
   <div id="facilities">
 <!-- first row -->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            Facility Name
          </label>
          <select name="facility" 
                  v-validate="modelValidations.facility"
                  v-model="model.facility"
                  v-on:change="showOtherFacility"
                  class="form-control">
            <option selected="" disabled="">- facility -</option>
                     <option>Barlow</option>
         <option>Dignity Infusion Ctr Camarillo</option>
         <option>Dignity Infusion Ctr Oxnard</option>
         <option>Dignity Infusion Ctr Ventura</option>
         <option>Dignity St. Johns PVH</option>
         <option>Dignity St. Johns RMC</option>
         <option>El Monte</option>
         <option>Encino</option>
         <option>Garfield</option>
         <option>HCA Los Robles</option>
         <option>HCA Riverside Community Facility</option>
         <option>HCA West Hills</option>
         <option>Hollywood Presbyterian</option>
         <option>Kaiser Moreno Valley</option>
         <option>Kindred La Mirada</option>
         <option>Kindred Ontario</option>
         <option>Kindred Riverside</option>
         <option>Kindred South Bay</option>
         <option>Monterey Park</option>
         <option>Northridge Facility</option>
         <option>Pacifica</option>
         <option>Pomona Valley</option>
         <option>Providence St Joseph Burbank </option>
         <option>Providence Tarzana</option>
         <option>SCH Hollywood</option>
         <option>SCH Van Nuys</option>
         <option>Sierra Vista Rehab</option>
         <option>Other</option>
          </select>
          <small class="text-danger" v-show="facility.invalid">
            {{ getError('facility') }}
          </small>
          <div class="form-group" v-show="visibleOtherFacility">
            <label style="margin-top:10px;" class="display:inline control-label">
              Other Facility
            </label>
            <input style="display:inline" class="form-control" ref="newOtherFacilityValue" type="text" name="otherFacility" v-model="model.otherFacility" />
          </div>
        </div>
      </div>
      <div class="col-md-5">
          <div class="form-group">
          <label class="control-label">
            Department
          </label>
          <input name="facilityDepartment"
                  type="text"
                  v-validate="modelValidations.facilityDepartment"
                  v-model="model.facilityDepartment"
                  class="form-control"
                  placeholder="ex: oncology"
          />
          <small class="text-danger" v-show="facilityDepartment.invalid">
            {{ getError('facilityDepartment') }}
          </small>
        </div>
      </div>
    </div>
<!-- second row -->
    <div class="row">
      <div class="col-md-5 col-md-offset-1">
                <div class="form-group">
          <label class="control-label">
            First Name
          </label>
          <input class="form-control"
                 type="text"
                 name="firstName"
                 ref="first"
                 v-validate="modelValidations.firstName"
                 v-model="model.firstName"
                 placeholder="ex: Jen"
          />
          <small class="text-danger" v-show="firstName.invalid">
            {{ getError('firstName') }}
          </small>
        </div>
      </div>
      <div class="col-md-5">
                <div class="form-group">
          <label class="control-label">
            Last Name
          </label>
          <input class="form-control"
                 type="text"
                 name="lastName"
                 ref="last"
                 v-validate="modelValidations.lastName"
                 v-model="model.lastName"
                 placeholder="ex: Thomas"
          />
          <small class="text-danger" v-show="lastName.invalid">
            {{ getError('lastName') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
         
        </div>
           
      </div>
    </div>
    </div> <!-- facilities -->
<!-- third row -->
    <div class="row">
      <div class="col-md-4 col-md-offset-1">
                <div class="form-group">
          <label class="control-label">
            Job Title/Position
          </label>
          <select name="jobTitle"
                  ref="jobTitleValue"
                  class="form-control"
                  v-validate="modelValidations.jobTitle"
                  v-model="model.jobTitle"
                  v-on:change="showOtherTitle">
                  <option>RN</option>
                  <option>CM</option>
                  <option>PT</option>
                  <option>OT</option>
                  <option>ST</option>
                  <option>RX</option>
                  <option>SW</option>
                  <option>Lab Scientist</option>
                  <option>Other</option>
          </select>
          <small class="text-danger" v-show="jobTitle.invalid">
            {{ getError('jobTitle') }}
          </small>

          <div class="form-group" v-show="visibleOtherTitle">
            <label style="margin-top:10px;" class="display:inline control-label">
              Other Title/Position
            </label>
            <input style="display:inline" class="form-control" ref="newOtherTitleValue" type="text" name="otherTitle" v-model="model.otherJobTitle" />
          </div>
        </div>
      </div>
            <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">
            Personal Email
          </label>
          <input type="email"
                 name="email"
                 v-validate="modelValidations.email"
                 v-model="model.email"
                 class="form-control">
          <small class="text-danger" v-show="email.invalid">
            {{ getError('email') }}
          </small>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="control-label">
            
          </label>
  <div class="checkbox checkbox-inline">
    <input type="checkbox" class="checkbox checkbox-inline" v-model="model.workingWithoutPpes">
    <label class="form-check-label" for="workingWithoutPpes">I am working without PPEs</label>
  </div>
      </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-7 col-md-offset-1">
                <div class="form-group">
          <label class="control-label">
            Comments
          </label>
          <textarea name="comments"
                  rows="3"
                  v-validate="modelValidations.comments"
                  v-model="model.comments"
                  class="form-control"
                  placeholder="Your comments..."
          />
          <small class="text-danger" v-show="comments.invalid">
            {{ getError('comments') }}
          </small>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label class="control-label">
            PPE Lack Date
          </label>
          <datetime value-zone="America/Los_Angeles" :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' }" class="form-control" type="datetime" v-model="model.incidentDate"></datetime>
        </div>
      </div>
    </div>

        <div id="what">
      <h4 class="text-center info-text seiu" style="margin-bottom:0px;margin-top:20px;">This is what I & my co-workers need to be safe at work.</h4>
      <p class="text-center info-text seiu" style="margin-bottom:25px;"> You can submit multiple times in a day and for multiple locations.</p>
  <div id="needs">
    <div class="row">
      <div class="col-md-6 text-center need-type">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="n95MasksNeed"
                v-model="model.needsN95Masks"
                v-on:change="checkQty">
                <span class="red">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  N95 masks<label style="display:inline" v-if="this.showN95MasksQty">: {{ this.model.n95MasksQty }} </label>
                </span>
            </label>
          </div>
          <div v-if="this.n95MasksInput" class="need-qty">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.n95MasksQty" ref="inputMask"
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="n95MasksNeedOK" class="btn btn-primary"  :disabled="!$refs.inputMask || $refs.inputMask.value < 1" v-on:click="updateQty">OK</button>
            <button name="n95MasksNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>
      <div class="col-md-6 text-center">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="gownsNeed"
                v-model="model.needsGowns"
                v-on:change="checkQty">
                <span class="red">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  Gowns<label style="display:inline" v-if="this.showGownsQty">: {{ this.model.gownsQty }} </label>
                </span>
            </label>
        ` </div>
          <div v-if="this.gownsInput" class="need-qty">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.gownsQty" ref="inputGown" 
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="gownsNeedOK" class="btn btn-primary" :disabled="!$refs.inputGown || $refs.inputGown.value < 1" v-on:click="updateQty">OK</button>
            <button name="gownsNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>
    </div>
<!-- Row 2 -->
    <div class="row">
      <div class="col-md-6 text-center need-type">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="respiratorHoodsNeed"
                v-model="model.needsRespiratorHoods"
                v-on:change="checkQty">
                <span class="purple">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  PAPR RESP HOODS<label style="display:inline" v-if="this.showRespiratorHoodsQty">: {{ this.model.respiratorHoodsQty }} </label>
                </span>
            </label>
          </div>
          <div v-if="this.respiratorHoodsInput" class="need-qty">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.respiratorHoodsQty" ref="inputRespirator" 
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="respiratorHoodsNeedOK" class="btn btn-primary" :disabled="!$refs.inputRespirator || $refs.inputRespirator.value < 1" v-on:click="updateQty">OK</button>
            <button name="respiratorHoodsNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>
      <div class="col-md-6 text-center">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="hazmatSuitsNeed"
                v-model="model.needsHazmatSuits"
                v-on:change="checkQty">
                <span class="purple">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  HAZMAT SUITS<label style="display:inline" v-if="this.showHazmatSuitsQty">: {{ this.model.hazmatSuitsQty }} </label>
                </span>
            </label>
        </div>
          <div v-if="this.hazmatSuitsInput" class="need-qty">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.hazmatSuitsQty" ref="inputHazmat"
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="hazmatSuitsNeedOK" class="btn btn-primary" :disabled="!$refs.inputHazmat || $refs.inputHazmat.value < 1" v-on:click="updateQty">OK</button>
            <button name="hazmatSuitsNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>      
    </div>
<!-- Row 3 -->
    <div class="row">
      <div class="col-md-6 text-center need-type">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="splashGuardsNeed"
                v-model="model.needsSplashGuards"
                v-on:change="checkQty">
                <span class="orange">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  SPLASH GUARDS<label style="display:inline" v-if="this.showSplashGuardsQty">: {{ this.model.splashGuardsQty }} </label>
                </span>
            </label>
          </div>
          <div v-if="this.splashGuardsInput" class="need-qty">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.splashGuardsQty" ref="inputSplash"
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="splashGuardsNeedOK" class="btn btn-primary" :disabled="!$refs.inputSplash || $refs.inputSplash.value < 1" v-on:click="updateQty">OK</button>
            <button name="splashGuardsNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>
      <div class="col-md-6 text-center">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="bootiesNeed"
                v-model="model.needsBooties"
                v-on:change="checkQty">
                <span class="orange">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  BOOTIES<label style="display:inline" v-if="this.showBootiesQty">: {{ this.model.bootiesQty }} </label>
                </span>
            </label>
        </div>
          <div v-if="this.bootiesInput" class="need-qty">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.bootiesQty" ref="inputBooties"
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="bootiesNeedOK" class="btn btn-primary" :disabled="!$refs.inputBooties || $refs.inputBooties.value < 1" v-on:click="updateQty">OK</button>
            <button name="bootiesNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>       
    </div>
<!-- Row 4 -->
    <div class="row">
      <div class="col-md-6 text-center need-type">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="eyeProtectionNeed"
                v-model="model.needsEyeProtection"
                v-on:change="checkQty">
                <span class="brown">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  EYE PROTECTION<label style="display:inline" v-if="this.showEyeProtectionQty">: {{ this.model.eyeProtectionQty }} </label>
                </span>
            </label>
          </div>
          <div v-if="this.eyeProtectionInput" class="need-qty">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.eyeProtectionQty" ref="inputEye"
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="eyeProtectionNeedOK" class="btn btn-primary" :disabled="!$refs.inputEye || $refs.inputEye.value < 1" v-on:click="updateQty">OK</button>
            <button name="eyeProtectionNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>
      <div class="col-md-6 text-center">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="bonnetsNeed"
                v-model="model.needsBonnets"
                v-on:change="checkQty">
                <span class="brown">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  BONNETS<label style="display:inline" v-if="this.showBonnetsQty">: {{ this.model.bonnetsQty }} </label>
                </span>
            </label>
        </div>
          <div v-if="this.bonnetsInput" class="need-qty" v-bind:class="{ badQty: isBadQty, 'text-danger': hasError }">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.bonnetsQty" ref="inputBonnet"
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="bonnetsNeedOK" class="btn btn-primary" :disabled="!$refs.inputBonnet || $refs.inputBonnet.value < 1" v-on:click="updateQty">OK</button>
            <button name="bonnetsNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>       
    </div>
<!-- Row 5 -->
    <div class="row">
      <div class="col-md-6 text-center need-type">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="glovesNeed"
                v-model="model.needsGloves"
                v-on:change="checkQty">
                <span class="purple">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  GLOVES<label style="display:inline" v-if="this.showGlovesQty">: {{ this.model.glovesQty }} </label>
                </span>
            </label>
          </div>
          <div v-if="this.glovesInput" class="need-qty">
            <label style="height=0; display:inline">Qty. Needed: </label>
            <input class="form-control" v-model="model.glovesQty"  ref="inputGlove" v-validate="'greaterThanZero'"
              type="number" min="1" style="display: inline; width:90px;"/>
            <button name="glovesNeedOK" class="btn btn-primary" :disabled="!$refs.inputGlove || $refs.inputGlove.value < 1" v-on:click="updateQty">OK</button>
            <button name="glovesNeedCancel" class="btn btn-primary" v-on:click="updateQtyCancel">X</button>
          </div>
      </div>
      <div class="col-md-6 text-center">
          <div class="btn-group" data-toggle="buttons">
            <label>
              <input class="form-control"
                type="checkbox"
                name="donDoffHelpNeed"
                v-model="model.needsDonDoffHelp"
                v-on:change="checkQty">
                <span class="purple">
                  <img alt="Glyphicons 89 address book" src="static/img/icons/glyphicons-89-address-book-6476e1f25deecdb2e5a0b982cde56ff1.png">
                  DON/DOFF HELP<label style="display:inline" v-if="this.model.needsDonDoffHelp">: YES </label>
                </span>
            </label>
        </div>
      </div>       
    </div>
    <!-- Row 6 -->
    <div class="row" v-if="showErrors">
      <div class="col-md-12">

      </div>
    </div>
    </div>
  </div> <!-- what ppes -->
  </div>
</template>
<script>
  import axios from 'axios'
  import {mapFields} from 'vee-validate'
  import { Datetime } from 'vue-datetime'
  import { VueTelInput } from 'vue-tel-input'
  import 'vue-datetime/dist/vue-datetime.css'

  export default {
    props: ['message'],
    computed: {
      ...mapFields(['workingWithoutPpes', 'comments', 'jobTitle', 'memberName', 'firstName', 'lastName', 'facility', 'facilityAddress', 'facilityDepartment', 'facilityPhone', 'email'])
    },
    data () {
      return {
        axios_config: {
          headers: {
            'Content-Type': 'application/json',
            'app_user_id': 'test_user',
            'app_user_name': 'Test User'
          }
        },
        visibleOtherTitle: false,
        visibleOtherFacility: false,
        isBadQty: false,
        hasError: true,
        validPpes: false,
        atLeastOne: false,
        showErrors: false,
        selected: '',
        n95MasksInput: false,
        showN95MasksQty: false,
        n95MasksError: false,
       // gowns
        gownsInput: false,
        showGownsQty: false,
        gownsError: false,
      // respiratorHoods
        respiratorHoodsInput: false,
        showRespiratorHoodsQty: false,
        respiratorsError: false,
      // other
        hazmatSuitsInput: false,
        showHazmatSuitsQty: false,
        hazmatsError: false,
      // splashGuards
        splashGuardsInput: false,
        showSplashGuardsQty: false,
        splashError: false,
      // booties
        bootiesInput: false,
        showBootiesQty: false,
        bootiesError: false,
      // eyeProtection
        eyeProtectionInput: false,
        showEyeProtectionQty: false,
        eyeProtectionError: false,
      // bonnets
        bonnetsInput: false,
        showBonnetsQty: false,
        bonnetsError: false,
      // gloves
        glovesInput: false,
        showGlovesQty: false,
        glovesError: false,
      // don/doff
        donDoffHelInput: false,
        showDonDoffHelpQty: false,
        donDoffError: false,
        products: [
          {id: 1, name: 'A'},
          {id: 2, name: 'B'},
          {id: 3, name: 'C'}
        ],
        facilities: [
          // { name: 'LAC + USC Medical Center - General Facility', address: '1200 N State St', city: 'Los Angeles', state: 'CA', zip: '90033', phone: '2136630567', longitude: '-118.430249', latitude: '34.0571762' },
          // { name: 'Kaiser Permanente', address: '1231 St.', city: 'Los Angeles', state: 'CA', zip: '92333', phone: '2131234567', longitude: '-118.430249', latitude: '34.218997' },
          // { name: 'VA Facility Long Beach', address: '5901 E 7th St.', city: 'Long Beach', state: 'CA', zip: '90822', phone: '5621234567', longitude: '-118.118666', latitude: '33.778737' },
          // { name: 'Providence St. Josephs', address: '501 S Buena Vista St.', city: 'Burbank', state: 'CA', zip: '91343', phone: '8181234567', longitude: '-118.328683', latitude: '34.156328' }
          { name: 'Barlow' },
          { name: 'Dignity Infusion Ctr Camarillo' },
          { name: 'Dignity Infusion Ctr Oxnard' },
          { name: 'Dignity Infusion Ctr Ventura' },
          { name: 'Dignity St. Johns PVH' },
          { name: 'Dignity St. Johns RMC' },
          { name: 'El Monte' },
          { name: 'Encino' },
          { name: 'Garfield' },
          { name: 'HCA Los Robles' },
          { name: 'HCA Riverside Community Facility' },
          { name: 'HCA West Hills' },
          { name: 'Hollywood Presbyterian' },
          { name: 'Kaiser Moreno Valley' },
          { name: 'Kindred La Mirada' },
          { name: 'Kindred Ontario' },
          { name: 'Kindred Riverside' },
          { name: 'Kindred South Bay' },
          { name: 'Monterey Park' },
          { name: 'Northridge Facility' },
          { name: 'Pacifica' },
          { name: 'Pomona Valley' },
          { name: 'Providence St Joe\'s Burbank ' },
          { name: 'Providence Tarzana' },
          { name: 'SCH Hollywood' },
          { name: 'SCH Van Nuys' },
          { name: 'Sierra Vista Rehab' }
        ],
        computedAddress: '',
        scrollToTop () {
          console.log(this.$el)
          this.$el.scrollTop = 0
          console.log('I am scrolling to the top')
        },
        model: {
          firstName: '',
          lastName: '',
          email: '',
          otherJobTitle: '',
          otherFacility: '',
          needsN95Masks: false,
          n95MasksQty: '',
          gownsQty: '',
          respiratorHoodsQty: '',
          splashGuardsQty: '',
          eyeProtectionQty: '',
          glovesQty: '',
          hazmatSuitsQty: '',
          bootiesQty: '',
          bonnetsQty: '',
          needsRespiratorHoods: false,
          needsSplashGuards: false,
          needsEyeProtection: false,
          needsGloves: false,
          needsGowns: false,
          needsHazmatSuits: false,
          needsBooties: false,
          needsBonnets: false,
          needsDonDoffHelp: false,
          donDoffHelpNeed: false,
          facility: '',
          facilityDepartment: '',
          workingWithoutPpes: false,
          jobTitle: '',
          incidentDate: '',
          comments: ''
        },
        modelValidations: {
          firstName: {
          },
          lastName: {
          },
          email: {

          },
          facility: {
            required: true
          },
          facilityDepartment: {
          },
          jobTitle: {
          },
          comments: {
          },
          bootiesQty: {
          }
        }
      }
    },
    created  () {
      this.$validator.extend('greaterThanZero', {
        getMessage: field => field + ' needs to be > zero.',
        validate: (value) => {
          // value must be > zero
          if (value > 0) return true
          return false
        }
      })
    },
    components: {
      datetime: Datetime,
      VueTelInput
    },
    methods: {
      updateAddress: function (event, inputs) {
        localStorage.setItem('facilityName', inputs.name)
        localStorage.setItem('facilityLatitude', inputs.latitude)
        localStorage.setItem('facilityLongitude', inputs.longitude)
        this.computedAddress = inputs.address + ', ' + inputs.city + ', ' + inputs.state + '  ' + inputs.zip
      },
      showOtherTitle: function () {
        if (this.model.jobTitle === 'Other') {
          this.visibleOtherTitle = true
        } else {
          this.visibleOtherTitle = false
        }
      },
      showOtherFacility: function () {
        if (this.model.facility === 'Other') {
          this.visibleOtherFacility = true
        } else {
          this.visibleOtherFacility = false
        }
      },
      checkQty: function (event) {
        if (event) {
          // alert(event.target.name)
          switch (event.target.name) {
            case 'n95MasksNeed':
              // code block
              if (this.model.needsN95Masks) {
                this.model.n95MasksQty = 1
              } else {
                this.model.n95MasksQty = 0
              }
              break
            case 'respiratorHoodsNeed':
              // code block
              if (this.model.needsRespiratorHoods) {
                this.model.respiratorHoodsQty = 1
              } else {
                this.model.respiratorHoodsQty = 0
              }
              break
            case 'splashGuardsNeed':
              // code block
              if (this.model.needsSplashGuards) {
                this.model.splashGuardsQty = 1
              } else {
                this.model.splashGuardsQty = 0
              }
              break
            case 'eyeProtectionNeed':
              // code block
              if (this.model.needsEyeProtection) {
                this.model.eyeProtectionQty = 1
              } else {
                this.model.eyeProtectionQty = 0
              }
              break
            case 'glovesNeed':
              // code block
              if (this.model.needsGloves) {
                this.model.glovesQty = 1
              } else {
                this.model.glovesQty = 0
              }
              break
            case 'gownsNeed':
              // code block
              if (this.model.needsGowns) {
                this.model.gownsQty = 1
              } else {
                this.model.gownsQty = 0
              }
              break
            case 'hazmatSuitsNeed':
              // code block
              if (this.model.needsHazmatSuits) {
                this.model.hazmatSuitsQty = 1
              } else {
                this.model.hazmatSuitsQty = 0
              }
              break
            case 'bootiesNeed':
              // code block
              if (this.model.needsBooties) {
                this.model.bootiesQty = 1
              } else {
                this.model.bootiesQty = 0
              }
              break
            case 'bonnetsNeed':
              // code block
              if (this.model.needsBonnets) {
                this.model.bonnetsQty = 1
              } else {
                this.model.bonnetsQty = 0
              }
              break
            case 'donDoffHelpNeed':
              // code block
              if (this.model.donDoffHelpNeed) {
                this.model.showDonDoffHelpQty = 1
              } else {
                this.model.showDonDoffHelpQty = 0
              }
              break
            default:
              // code block
          }
        }
      },
      updateQty () {
        if (event) {
          // alert(event.target.name)
          switch (event.target.name) {
            case 'n95MasksNeedOK':
              // code block
              if (this.model.n95MasksQty !== '') {
                this.showN95MasksQty = true
                this.n95MasksInput = false
              } else {
                this.showN95MasksQty = false
                this.n95MasksInput = false
              }
              break
            case 'respiratorHoodsNeedOK':
              // code block
              if (this.model.respiratorHoodsQty !== '') {
                this.showRespiratorHoodsQty = true
                this.respiratorHoodsInput = false
              } else {
                this.showRespiratorHoodsQty = false
                this.respiratorHoodsInput = false
              }
              break
            case 'splashGuardsNeedOK':
              // code block
              if (this.model.splashGuardsQty !== '') {
                this.showSplashGuardsQty = true
                this.splashGuardsInput = false
              } else {
                this.showSplashGuardQty = false
                this.splashGuardsInput = false
              }
              break
            case 'eyeProtectionNeedOK':
              // code block
              if (this.model.eyeProtectionQty !== '') {
                this.showEyeProtectionQty = true
                this.eyeProtectionInput = false
              } else {
                this.showEyeProtectionQty = false
                this.eyeProtectionInput = false
              }
              break
            case 'glovesNeedOK':
              // code block
              if (this.model.glovesQty !== '') {
                this.showGlovesQty = true
                this.glovesInput = false
              } else {
                this.showGlovesQty = false
                this.glovesInput = false
              }
              break
            case 'gownsNeedOK':
              // code block
              if (this.model.gownsQty !== '') {
                this.showGownsQty = true
                this.gownsInput = false
              } else {
                this.showGownsQty = false
                this.gownsInput = false
              }
              break
            case 'hazmatSuitsNeedOK':
              if (this.model.hazmatSuitsQty !== '') {
                this.showHazmatSuitsQty = true
                this.hazmatSuitsInput = false
              } else {
                this.showHazmatSuitsQty = false
                this.hazmatSuitsInput = false
              }
              break
            case 'bootiesNeedOK':
              // code block
              if (this.model.bootiesQty !== '') {
                this.showBootiesQty = true
                this.booBootiesGownsQty = false
                this.bootiesInput = false
              } else {
                this.showBoootiesQty = false
                this.bootiesInput = false
              }
              break
            case 'bonnetsNeedOK':
              // code block
              if (this.model.bonnetsQty !== '') {
                this.showBonnetsQty = true
                this.bonnetsInput = false
              } else {
                this.showBonnetsQty = false
                this.bonnetsInput = false
              }
              break
            case 'donDoffHelpNeedOK':
              break
            default:
              // code block
          }
        }
      },
      updateQtyCancel () {
        if (event) {
          switch (event.target.name) {
            case 'n95MasksNeedCancel':
              // code block
              this.model.n95MasksQty = ''
              this.model.needsN95Masks = false
              this.n95MasksInput = false
              this.showN95MasksQty = false
              break
            case 'respiratorHoodsNeedCancel':
              // code block
              this.model.respiratorHoodsQty = ''
              this.model.needsRespiratorHoods = false
              this.respiratorHoodsInput = false
              this.showRespiratorHoodsQty = false
              break
            case 'splashGuardsNeedCancel':
              // code block
              this.model.splashGuardsQty = ''
              this.model.needsSplashGuards = false
              this.splashGuardsInput = false
              this.splashGuardsQty = false
              break
            case 'eyeProtectionNeedCancel':
              // code block
              this.model.eyeProtectionQty = ''
              this.model.needsEyeProtection = false
              this.eyeProtectionInput = false
              this.eyeProtectionQty = false
              break
            case 'glovesNeedCancel':
              // code block
              this.model.glovesQty = ''
              this.model.needsGloves = false
              this.glovesInput = false
              this.glovesQty = false
              break
            case 'gownsNeedCancel':
              // code block
              this.model.gownsQty = ''
              this.model.needsGowns = false
              this.gownsInput = false
              this.gownsQty = false
              break
            case 'hazmatSuitsNeedCancel':
              // code block
              this.model.hazmatSuitsQty = ''
              this.model.needsHazmatSuits = false
              this.hazmatSuitsInput = false
              this.hazmatSuitsQty = false
              break
            case 'bootiesNeedCancel':
              // code block
              this.model.bootiessQty = ''
              this.model.needsBooties = false
              this.bootiesInput = false
              this.bootiesQty = false
              break
            case 'bonnetsNeedCancel':
              // code block
              this.model.bonnetsQty = ''
              this.model.needsBonnets = false
              this.bonnetsInput = false
              this.bonnetsQty = false
              break
            case 'donDoffHelpNeedCancel':
              break
            default:
              // code block
          }
        }
      },
      // model.n95MasksQty
      checkn95MasksQty () {
        if (this.model.needsN95Masks) {
          this.n95MasksInput = true
        } else {
          this.n95MasksInput = false
          this.showN95MasksQty = false
          this.model.n95MasksQty = ''
        }
      },
      updateMaskQty () {
        if (this.model.n95MasksQty !== '') {
          this.showN95MasksQty = true
          this.n95MasksInput = false
        } else {
          this.showN95MasksQty = false
          this.n95MasksInput = false
        }
      },
      updateMaskQtyCancel () {
        this.model.n95MasksQty = ''
        this.model.needsN95Masks = false
        this.n95MasksInput = false
        this.showN95MasksQty = false
      },
      // model.respiratorHoodsQty
      checkRespiratorHoodsQty () {
        if (this.model.needsRespiratorHoods) {
          this.respiratorHoodsInput = true
        } else {
          this.respiratorHoodsInput = false
          this.showRespiratorHoodsQty = false
          this.model.respiratorHoodsQty = ''
        }
      },
      updateRespiratorHoodsQty () {
        if (this.model.respiratorHoodsQty !== '') {
          this.showRespiratorHoodsQty = true
          this.respiratorHoodsInput = false
        } else {
          this.showRespiratorHoodsQty = false
          this.respiratorHoodsInput = false
        }
      },
      updateRespiratorHoodsQtyCancel () {
        this.model.respiratorHoodsQty = ''
        this.model.needsRespiratorHoods = false
        this.respiratorHoodsInput = false
        this.showRespiratorHoodsQty = false
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return (this.$validator.validateAll())
      },
      isPositiveInteger (n) {
        return !isNaN(n) && +n > 0
        // return Number.isInteger(n) && n > 0
      },
      atLeastOnePpp () {
        if (this.model.needsN95Masks || this.model.needsRespiratorHoods || this.model.needsSplashGuards || this.model.needsEyeProtection || this.model.needsGloves || this.model.needsGowns || this.model.needsHazmatSuits || this.model.needsBooties || this.model.needsBonnets || this.model.needsDonDoffHelp) {
          return true
        }
      },
      hasPpeError () {
        if (this.n95MasksError || this.respiratorsError || this.splashError || this.eyeProtectionError || this.glovesError || this.gownsError || this.hazmatsError || this.bootiesError || this.bonnetsError) {
          return true
        }
      }
    }
  }
</script>
<style>

#id_work_days input[type="checkbox"] {
  display: none;
}

#id_work_days span {
  display: inline-block;
  padding: 10px;
  text-transform: uppercase;
  border: 2px solid gold;
  border-radius: 3px;
  color: gold;
}

#id_work_days input[type="checkbox"]:checked + span {
  background-color: gold;
  color: black;
}

#needs input[type="checkbox"] {
  display: none;
}
#needs span {
  display: inline-block;
  padding: 10px;
  text-transform: uppercase;
  border: 2px solid gold;
  border-radius: 10px;
  color: gold;
  width: 100%;
}

#needs input[type="checkbox"]:checked + span {
  background-color: gold;
  color: black;
}


#needs input[type="checkbox"]:checked {
  background-color: gold;
  color: black;
}

#needs span.red {
	border-color: #cc0000;
	color: #cc0000;
}

#needs span.orange {
	border-color: #ff8800;
	color: #ff8800;
}

#needs span.green {
	border-color: #77b300;
	color: #77b300;
}

#needs span.brown {
	border-color: #8B4513;
	color: #8B4513;
}

#needs span.purple {
	border-color: #9933cc;
	color: #9933cc;
}

.vdatetime-input {
	border: 0;
	background-color: transparent;
}

.vti__dropdown {
	display: none !important;
}

.vti__input {
	background-color: #F3F2EE !important;
}

.vue-tel-input {
	border-radius: 3px;
	display: flex;
  border: none !important;
	text-align: left;
}


.vue-tel-input {
  border: unset !important;
}
.vue-tel-input:focus-within {
  box-shadow: unset !important;
}
.vue-tel-input:focus {
  box-shadow: unset !important;
  border-color: #7AC29A !important;
}

.phone-input {
  background-color: #F3F2EE;
  border: 1px solid #e8e7e3;
  border-radius: 4px;
  color: #52514d;
  font-size: 14px;
  padding: 7px 18px;
  height: 40px;
  -webkit-box-shadow: none;
  box-shadow: none; 
}

.phone-input:focus {
	border: 1px solid #7AC29A;
	background-color: #F3F2EE;
	-webkit-box-shadow: none;
	box-shadow: none;
	outline: 0 !important;
}

.phone-input:focus {
		border: 1px solid #7AC29A;
	background-color: #F3F2EE;
	border-radius: 0 2px 2px 0;
	width: 100%;
	outline: 0;
	padding-left: 7px;
}

/*
####################################################
M E D I A  Q U E R I E S
####################################################
*/
 
/*
::::::::::::::::::::::::::::::::::::::::::::::::::::
Bootstrap 4 breakpoints
*/
 
/* 
Extra small devices (portrait phones, less than 576px) 
No media query since this is the default in Bootstrap because it is "mobile first"
*/
 
/* Small devices (landscape phones, 576px and up) */
@media (min-width: 320px) {  
  #what label {
    width: 100%;
    height: 50px;
    font-size: 16px;
  }

  #what .btn-group {
    width: 80%;
    height: 50px;
    font-size: 17px;
    margin-bottom: 5px;
}
#what .quant-group {
    width: 20%;
    height: 50px;
    font-size: 9px;
    margin-bottom: 2px;
}
#what .quant-group label {
    width: 20%;
    height: 30px;
    font-size: 9px;
    margin-left: 10px;
}
#what label img {
    float: left;
}


}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 575px) {  
  .header-section {
	margin-left: -15px;
	margin-right: -15px;
}
.wizard-tab-container h4 {
  margin-top: 5px;
}

.text-danger {
  color: red;
}
}


 
/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {  
  .header-section {
	margin-left: -15px;
	margin-right: -15px;
}
}
 
/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {  
 
}
 
/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) { 

}
 
/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {  
    
}

/*
::::::::::::::::::::::::::::::::::::::::::::::::::::
Custom media queries
*/
 
/* Set width to make card deck cards 100% width */
@media (max-width: 950px) { 
 
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Wizard/FirstStep.vue